import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { History } from '../shared/history.model';
import { MatTableDataSource } from '@angular/material';

export interface Transaction {
  item: string;
  cost: number;
}


@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss']
})
export class HistoryComponent implements OnInit , OnChanges {

  displayedColumns: string[] = ['semestre', 'version', 'materia' , 'nombre' , 'nota' , 'creditos' , 'homologacion', 'consecutivo'];

  @Input() semestre: String;
  @Input() historia:  History[];

  /** Gets the total cost of all transactions. */
  getTotalCost() {
   return this.historia.map((subject) => {
      return Number(subject.nroCreditos);
    }).reduce((acc, value) => acc + value, 0);
  }

  constructor() {
  }

  getNumberCredit (creditos) {
    return Number(creditos);
  }

  ngOnInit() {
  }

  ngOnChanges() {
// console.log(this.historia);
  }

}
